// components
import ComponentsRender from '@/components/ComponentsRender';

// constants
import { COMPONENTS } from '@/components/components';

// Passthrough layout: renders its children with no wrapper/background/padding.
// Lets full-bleed webinar blocks and regular components be composed together
// and reused on any page.
const FragmentLayout = ({ fragmentLayoutContent: content }) => (
  <>
    {(content || []).map((component) => (
      <ComponentsRender key={`${component.id}_${component.__typename}`} type={COMPONENTS} component={component} />
    ))}
  </>
);

export default FragmentLayout;
